import { AlertCircle, CheckCircle2, Info, X } from "lucide-react";
import type { ToastNotice } from "../types";

export function ToastViewport(props: { notices: ToastNotice[]; onDismiss(id: number): void }) {
  return (
    <div className="toast-viewport" aria-label="Notifications">
      {props.notices.map((notice) => (
        <div className={`toast ${notice.tone}`} role={notice.tone === "error" ? "alert" : "status"} key={notice.id}>
          <span className="toast-icon">{toastIcon(notice.tone)}</span>
          <p>{notice.message}</p>
          <button type="button" onClick={() => props.onDismiss(notice.id)} aria-label="Fermer la notification" title="Fermer">
            <X aria-hidden="true" />
          </button>
        </div>
      ))}
    </div>
  );
}

function toastIcon(tone: ToastNotice["tone"]) {
  if (tone === "success") return <CheckCircle2 aria-hidden="true" />;
  if (tone === "error") return <AlertCircle aria-hidden="true" />;
  return <Info aria-hidden="true" />;
}
